<app-modal-icon [type]="'info'"></app-modal-icon>

<div class="info-content">
  <p>
    {{ messageKey | translate: params }}
  </p>

  <p *ngIf="questionKey">
    {{ questionKey | translate }}
  </p>

  <app-modal-buttons-group>
    <button pso-outline-button (click)="noClicked.emit()">
      {{ 'no' | translate | uppercase }}
    </button>

    <button pso-button [color]="'primary-b-blue'" (click)="finishClicked.emit()">
      {{ 'yes' | translate | uppercase }}
    </button>
  </app-modal-buttons-group>
</div>
